import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { InfoByQrCode } from 'src/app/shared/models/scanv1';
import { MassAttachToMail, ScanFromDelibe, ScanFromDelibePaginate } from 'src/app/shared/models/iScanV1/scan-from-delibe';
import { AddScanIDelibe } from 'src/app/shared/models/iScanV1/add-scan-idelibe';

const headers = new HttpHeaders({
  'Content-Type': 'application/json',
});

@Injectable({
  providedIn: 'root',
})
export class ScanService {
  public issuer: string;
  public apiGatewayBaseUrl: string;

  constructor(private http: HttpClient) {
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    this.issuer = config.issuer;
    this.apiGatewayBaseUrl = config.apiGatewayBaseUrl + '/api/v1';
  }

  public getInfoCourrierByIdQrCode(id: { courrierIds: number[] }): Observable<InfoByQrCode[]> {
    return this.http.post(`${this.apiGatewayBaseUrl}/Global/GetSceancesPointsFromQR`, id).pipe(
      map((res: InfoByQrCode[]) => {
        return res;
      })
    );
  }

  getScanLots(params?: { [key: string]: string | number | number[] }): Observable<ScanFromDelibePaginate> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        httpParams = httpParams.set(key, params[key].toString());
      });
    }
    return this.http.get(`${this.apiGatewayBaseUrl}/ScanLots/Search`, { params: httpParams }).pipe(
      map((res: ScanFromDelibePaginate) => {
        return res;
      })
    );
  }

  createScan(data: AddScanIDelibe): Observable<ScanFromDelibe> {
    return this.http.post(`${this.apiGatewayBaseUrl}/ScanLots`, data).pipe(
      map((res: ScanFromDelibe) => {
        return res;
      })
    );
  }

  updateStatusScan(data: {lotGuids: string[], status: string}): Observable<ScanFromDelibe> {
    return this.http.put(`${this.apiGatewayBaseUrl}/ScanLots/Status`, data).pipe(
      map((res: ScanFromDelibe) => {
        return res;
      })
    );
  }
  
  deleteScan(lotGuids: string[]): Observable<boolean> {
    /*console.log('service');
    let params = new HttpParams();
    lotGuids.forEach(guid => {
      params = params.append('lotGuids', guid);
    });
    */

    return this.http.delete<boolean>(`${this.apiGatewayBaseUrl}/ScanLots`, { params: {lotGuids: lotGuids.join(',')} }).pipe(
      map((res: boolean) => {
        return res;
      })
    );
  }

  massAttachToMail(data: MassAttachToMail[], scanLotProcessed: boolean): Observable<number> {
    const params = new HttpParams().set('scanLotProcessed', scanLotProcessed.toString());
    return this.http.put<number>(`${this.apiGatewayBaseUrl}/ScanLots/MassAttachToMail`, data, { params }).pipe(
      map((res: number) => {
        console.log('res service ==>', res);
        return res;
      })
    );
  }
}
